
namespace TabAurous.OMS
{
    @Serenity.Decorators.registerEditor()
    export class ProductSizeMasterEditor extends Serenity.Select2Editor<any, any> {
        constructor(container: JQuery) {
            super(container, null);

            // add option accepts a key (id) value and display text value
            this.addOption("Diameter", "Diameter");
            this.addOption("Circumference", "Circumference");
            this.addOption("Length", "Length")

        }
    }
}
